import { render } from "./EditDeleteMachine.vue?vue&type=template&id=10f4348b"
import script from "./EditDeleteMachine.vue?vue&type=script&lang=js"
export * from "./EditDeleteMachine.vue?vue&type=script&lang=js"

import "./EditDeleteMachine.vue?vue&type=style&index=0&id=10f4348b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__